import React from "react";
import { RotateCcw } from "lucide-react";

// Keeps the lesson page alive if one game crashes.
export class GameBoundary extends React.Component {
  state = { err: false };

  static getDerivedStateFromError() { return { err: true }; }

  componentDidCatch(e) { console.error("Lesson game crashed:", e); }

  render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="mt-4 rounded-2xl border border-dashed border-border bg-card p-4 text-sm" data-testid="game-boundary-error">
        <p className="font-semibold">Sorry, this game couldn't load. The rest of the lesson still works.</p>
        <button type="button" onClick={() => this.setState({ err: false })} data-testid="game-boundary-retry"
          className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-primary px-4 py-1.5 text-xs font-semibold text-primary">
          <RotateCcw size={13} /> Try again
        </button>
      </div>
    );
  }
}
